<template>
    <div>
        <div v-if="original">
            <slot></slot>
        </div>
        <div v-if="!original">
            <div class="grid grid-col-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                <div
                    v-for="item in results"
                    :id="'x-p' + item.p_aid"
                    v-bind:key="item.p_aid"
                    class="bg-white rounded shadow"
                >
                    <a :href="propertyLink(item)" class="proplink">
                        <figure class="relative m-0">
                            <span
                                class="absolute font-nova-bold text-xs bg-sky-700 text-white p-2 z-10 rounded-tl"
                                >{{ item.p_property_type }}</span
                            >
                            <span v-if="item.readable_arrive" class="lastMin">{{
                                item.readable_arrive
                            }}</span>
                            <span
                                v-if="
                                    item.p_late_availability &&
                                        !item.readable_arrive
                                "
                                class="lastMin"
                                >LATE AVAILABILITY</span
                            >
                            <div
                                v-if="item.p_pet_friendly"
                                class="lazyload pet-stamp"
                                data-bg="https://images.simplyowners.net/geo/types/icon-pet-stamp.png"
                            ></div>
                            <div
                                v-if="isNhsStampVisible(item)"
                                class="lazyload nhs-stamp"
                                data-bg="https://images.simplyowners.net/geo/types/icon-nhs-stamp.png"
                            ></div>
                            <div
                                v-if="item.p_wheelchair_access"
                                class="lazyload wc-stamp"
                                data-bg="https://images.simplyowners.net/geo/types/icon-wheelchair-stamp.png"
                            ></div>
                            <slider-component
                                :alt="
                                    item.p_name
                                        ? item.p_name +
                                          ' (P' +
                                          item.p_aid +
                                          ')' +
                                          ' - ' +
                                          item.p_bedrooms +
                                          ' Bedroom Self Catering ' +
                                          item.p_property_type +
                                          ' in ' +
                                          item.p_highlights_text
                                        : 'P' +
                                          item.p_aid +
                                          ' - ' +
                                          item.p_bedrooms +
                                          ' Bedroom Self Catering ' +
                                          item.p_property_type +
                                          ' in ' +
                                          item.p_highlights_text
                                "
                                :images="item.images"
                                :pid="item.p_aid"
                                :thumb="item.thumb"
                            ></slider-component>
                        </figure>
                        <div class="propdetails">
                            <div class="propdesc">
                                {{ truncateString(item.p_title, 220) }}
                            </div>
                            <div class="break"></div>
                            <div class="proplayout">
                                <i class="icon-users text-so-green"></i>Sleeps
                                {{ item.p_sleeps }}
                            </div>
                            <div class="proplayout">
                                <i class="icon-bed text-so-green"></i
                                >{{ pluralString(item.p_bedrooms, "Bedroom") }}
                            </div>
                            <div class="proplayout">
                                <i class="icon-bath text-so-green"></i
                                >{{ pluralString(item.bathrooms, "Bathroom") }}
                            </div>
                            <div class="break"></div>
                            <div
                                v-for="facility in item.propertyFacilities"
                                class="badge badge-prop"
                            >
                                <span v-if="facility.name === 'Child Friendly'"
                                    >Child Friendly</span
                                >
                                <span
                                    v-else-if="facility.name === 'Pet Friendly'"
                                    >Pet Friendly</span
                                >
                                <span
                                    v-else-if="
                                        facility.name === 'Air Conditioning'
                                    "
                                    >Air Con</span
                                >
                                <span v-else>{{ facility.name }}</span>
                            </div>
                        </div>
                    </a>
                    <div
                        class="proplocation overflow-hidden overflow-ellipsis text-right"
                    >
                        {{ propLocation(item.p_property_type) }} in
                        <a :href="'/' + item.gl_url_new + '/'">{{
                            item.p_highlights_text
                        }}</a>
                    </div>
                    <div class="propfooter">
                        <div>
                            <div v-if="item.p_review_count > 0">
                                <div class="review_stars">
                                    <img
                                        :alt="
                                            Math.ceil(item.p_average_rating) +
                                                ' stars'
                                        "
                                        :src="
                                            'https://images.simplyowners.net/assets/stars_' +
                                                Math.ceil(
                                                    item.p_average_rating
                                                ) +
                                                '.png'
                                        "
                                        height="15"
                                        width="76"
                                    />
                                </div>

                                <div class="review_count">
                                    <a
                                        :href="
                                            '/' +
                                                item.gl_url_new +
                                                '/p/' +
                                                item.p_aid +
                                                '/#reviews'
                                        "
                                    >
                                        {{
                                            pluralString(
                                                item.p_review_count,
                                                " review"
                                            )
                                        }}</a
                                    >
                                </div>
                            </div>
                        </div>
                        <div>
                            <faves-component
                                :pid="item.p_aid"
                            ></faves-component>
                        </div>
                        <div>
                            <div
                                v-if="
                                    item.display_price &&
                                        item.new_price == 1 &&
                                        priceToCalendar == 1
                                "
                            >
                                <div
                                    v-if="
                                        !item.date_set && !item.week_price_low
                                    "
                                >
                                    <div class="price">
                                        {{
                                            item.currency_symbol +
                                                item.display_price
                                        }}
                                    </div>
                                    <div class="SO_price_avg">a day</div>
                                </div>
                                <div
                                    v-if="
                                        item.week_price_low &&
                                            item.week_price_high &&
                                            !item.date_set &&
                                            item.week_price_low ==
                                                item.week_price_high
                                    "
                                >
                                    <div class="SO_price_top">from</div>
                                    <div class="price">
                                        {{
                                            item.currency_symbol +
                                                item.week_price_low
                                        }}
                                    </div>
                                    <div class="SO_price_avg">a week</div>
                                </div>
                                <div
                                    v-if="
                                        !item.date_set &&
                                            item.week_price_low &&
                                            item.week_price_high &&
                                            item.week_price_low !=
                                                item.week_price_high
                                    "
                                    class="price-container"
                                >
                                    <div class="SO_price_top_new">
                                        from
                                    </div>
                                    <div
                                        :style="{
                                            fontSize:
                                                item.week_price_high > 9999
                                                    ? '16px'
                                                    : '18px'
                                        }"
                                        class="new_price"
                                    >
                                        {{
                                            item.currency_symbol +
                                                item.week_price_low ?? "poa"
                                        }}
                                        -
                                        {{
                                            item.currency_symbol +
                                                item.week_price_high ?? "poa"
                                        }}
                                    </div>
                                    <div class="SO_price_avg">
                                        a week
                                    </div>
                                </div>
                                <div v-if="item.date_set">
                                    <div class="ptc">
                                        {{
                                            item.currency_symbol +
                                                item.display_price
                                        }}
                                    </div>
                                    <div class="SO_price_avg">for stay</div>
                                </div>
                            </div>
                            <div v-else class="price">POA</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { store } from "./store";
import SliderComponent from "./SliderComponent.vue";
import FavesComponent from "./FavesComponent.vue";

export default {
    name: "ResultsComponent",
    components: {
        SliderComponent,
        FavesComponent
    },
    data() {
        return {
            shared: store,
            original: true,
            priceToCalendar: import.meta.env.VITE_PRICE_TO_CALENDAR ?? "0"
        };
    },
    methods: {
        pluralString(number, string) {
            if (number === 1) {
                return number + " " + string;
            }
            return number + " " + string + "s";
        },
        truncateString(string, limit) {
            if (string.length > limit) {
                return string.substring(0, limit) + "...";
            }
            return string;
        },
        propLocation(type) {
            var propertyType;
            if (type === "Cottage") {
                propertyType = "Holiday Cottage";
            } else if (type === "Villa") {
                propertyType = "Villa Rental";
            } else if (type === "") {
                propertyType = "Holiday Rental";
            } else {
                propertyType = type;
            }
            return propertyType;
        },

        propertyLink(item) {
            let link = "/" + item.gl_url_new + "/p/" + item.p_aid + "/";

            if (item.arrive && item.nights) {
                link += item.arrive + "/" + item.nights + "/";
            }

            return link;
        },

        isNhsStampVisible(item) {
            if (!item.show_nhs) return false;

            const now = new Date();
            const showNhsDate = new Date(item.show_nhs);

            return showNhsDate >= now;
        }
    },
    computed: {
        results() {
            return store.state.results;
        }
    },
    watch: {
        results() {
            if (this.results !== null) {
                this.original = false;
            }
        }
    }
};
</script>
